module.exports = __webpack_public_path__ + "img/1800espresso_back.3c2347d4.jpg";